import { AxiosResponse } from "axios"
import { useMutation } from "react-query"

import { IDeleteCustomerRes } from "types/customer"
import customersService from "api/customersService"

const useDeleteCustomerMutation = () => {
  return useMutation(async (customerId: string) => {
    try {
      const res: AxiosResponse<IDeleteCustomerRes> = await customersService.deleteCustomer(customerId)

      return res.data
    } catch(err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  })
}

export default useDeleteCustomerMutation